module.exports = __webpack_public_path__ + "static/media/checkbox-filled.61cd1f2a.svg";